import { StyledColumn } from './styles';

export const Column = StyledColumn;
